import { APPLICANT_ATTENTION_ACTION_KEY } from '../RentalPortalApplicantProfile.constants'
import { APPLICANT_COMPLIANCE_SCREENING_STATUS } from '../RentalPortalApplicantProfileCompliance'

export const QA_NAME_APPLICANT_PROFILE_WIDGET_STAGE_SCREENING =
  'applicantProfileWidgetStageScreening'

export const QA_NAME_APPLICANT_PROFILE_SCREENING_COUNT =
  'applicantProfileScreeningCount'

export const QA_NAME_APPLICANT_PROFILE_STAGE_MIRROR =
  'applicantProfileStageMirror'

export const APPLICANT_STAGE_SCREENING_GROUP = {
  decision: 'decision',
  screening: 'screening',
}

export const APPLICANT_STAGE_SCREENING_GROUP_TITLE_KEY = {
  [APPLICANT_STAGE_SCREENING_GROUP.decision]:
    'RentalPortal.ApplicantProfileDecisionGroupKey',
  [APPLICANT_STAGE_SCREENING_GROUP.screening]:
    'RentalPortal.ApplicantProfileScreeningGroupCountKey',
}

export const APPLICANT_STAGE_SCREENING_TITLE_SEPARATOR = '·'

export const APPLICANT_CHECK_KEY = {
  consent: 'consent',
  creditCheck: 'credit_check',
  documents: 'documents',
  fourEyes: 'four_eyes',
  handoff: 'handoff',
  sanctions: 'sanctions',
  selected: 'selected',
}

export const APPLICANT_CHECK_LABEL_KEY = {
  [APPLICANT_CHECK_KEY.consent]: 'RentalPortal.ApplicantCheckConsentKey',
  [APPLICANT_CHECK_KEY.creditCheck]:
    'RentalPortal.ApplicantCheckCreditCheckKey',
  [APPLICANT_CHECK_KEY.documents]: 'RentalPortal.ApplicantCheckDocumentsKey',
  [APPLICANT_CHECK_KEY.fourEyes]: 'RentalPortal.ApplicantCheckFourEyesKey',
  [APPLICANT_CHECK_KEY.handoff]: 'RentalPortal.ApplicantCheckHandoffKey',
  [APPLICANT_CHECK_KEY.sanctions]: 'RentalPortal.ApplicantCheckSanctionsKey',
  [APPLICANT_CHECK_KEY.selected]: 'RentalPortal.ApplicantCheckSelectedKey',
}

export const APPLICANT_SANCTIONS_CLEARED_STATUSES = [
  APPLICANT_COMPLIANCE_SCREENING_STATUS.clear,
  APPLICANT_COMPLIANCE_SCREENING_STATUS.clearedFalsePositive,
]

export const APPLICANT_CREDIT_CHECK_HINT_KEY = {
  awaitingConsent: 'RentalPortal.ApplicantCheckCreditCheckAwaitingConsentKey',
  awaitingReport: 'RentalPortal.ApplicantCheckCreditCheckAwaitingReportKey',
  expired: 'RentalPortal.ApplicantCheckCreditCheckExpiredKey',
  met: 'RentalPortal.ApplicantCheckCreditCheckMetKey',
  metSupplementary: 'RentalPortal.ApplicantCheckCreditCheckMetSupplementaryKey',
  noData: 'RentalPortal.ApplicantCheckCreditCheckNoDataKey',
  requested: 'RentalPortal.ApplicantCheckCreditCheckRequestedKey',
  verdictOpen: 'RentalPortal.ApplicantCheckCreditCheckVerdictOpenKey',
}

export const APPLICANT_CREDIT_CHECK_RESULT_ROLE_SUPPLEMENTARY = 'supplementary'

export const APPLICANT_ATTENTION_ACTION_ROW_KEY = {
  [APPLICANT_ATTENTION_ACTION_KEY.approve]: APPLICANT_CHECK_KEY.fourEyes,
  [APPLICANT_ATTENTION_ACTION_KEY.recordVerdict]:
    APPLICANT_CHECK_KEY.creditCheck,
}

export const APPLICANT_STAGE_SCREENING_SKELETON_GROUP_ROW_COUNT = [4, 3]
